export const PWA_APPS = {
  player: {
    name: "タマリバ",
    color: "#ff7b14",
    path: "/",
    description: "",
  },
  admin: {
    name: "タマリバ Admin",
    color: "#0093d2",
    path: "/admin",
    description: "タマリバの運営管理画面。",
  },
  store: {
    name: "タマリバ 店舗",
    color: "#00b878",
    path: "/store",
    description: "タマリバの店舗管理画面。",
  },
  // Reserved for the future manufacturer portal; this does not add its UI.
  manufacturer: {
    name: "タマリバ メーカー",
    color: "#f64c5a",
    path: "/manufacturer",
    description: "タマリバのメーカー管理画面。",
  },
} as const;

export type PwaApp = keyof typeof PWA_APPS;

export function isPwaApp(value: string): value is PwaApp {
  return Object.hasOwn(PWA_APPS, value);
}

// Hosts select presentation only. Authentication and authorization remain in API.
export function pwaAppForHost(host: string): PwaApp {
  const label = host.toLowerCase().split(":")[0]?.split(".")[0] ?? "";
  return isPwaApp(label) ? label : "player";
}

export function pwaAppForPath(
  path: string,
  fallback: PwaApp = "player",
): PwaApp {
  for (const app of ["admin", "store", "manufacturer"] as const) {
    const root = PWA_APPS[app].path;
    if (path === root || path.startsWith(`${root}/`)) return app;
  }
  return fallback;
}

export function manifestPath(app: PwaApp): string {
  return app === "player"
    ? "/manifest.webmanifest"
    : `/manifest.webmanifest?app=${app}`;
}

export function installIconPath(app: PwaApp, size: string): string {
  return `/install-icon/${app === "player" ? "" : `${app}/`}${size}`;
}
